import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

import {khoziApi} from "./services/khozi";


/*const store = configureStore({ 
  reducer: {
    rootReducer, 
    [khoziApi.reducerPath]: khoziApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({serializableCheck: false})
    .concat(khoziApi.middleware),
  devTools: true 
});*/


const store = configureStore({ 
  reducer: rootReducer, 
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({serializableCheck: false})
    .concat(khoziApi.middleware),
  devTools: false 
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
export type AppDispatch = typeof store.dispatch;
